import React from "react";
import { Vocabulary } from "../../Utils/Vocabulary";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

// Catches render-time exceptions in the wrapped subtree so a single bad
// component (e.g. corrupted cached data) doesn't unmount the whole app.
export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error("Unhandled UI error caught by ErrorBoundary", error, errorInfo);
  }

  private handleReload = (): void => {
    window.location.reload();
  };

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, textAlign: "center" }}>
          <p>{Vocabulary.unexpectedApplicationError}</p>
          <button onClick={this.handleReload}>{Vocabulary.reloadPage}</button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
